/**
 * Department type codes used by the resident admin API to scope a resident
 * search to an audience. Mirrors `UserServiceConstants` on the User API.
 *
 * `All` is the API sentinel that disables explicit department filtering,
 * returning residents across all eligible departments (Independent and
 * Serviced, not CARE); prefer explicit codes for event bookings so the
 * intended audience is unambiguous.
 */
export enum DepartmentTypeCode {
  Independent = "IND",
  Serviced = "SA",
  All = "ALL"
}
